

var tempDemographicsLocalStorageName = 'ehrLocalStorageDemographicsInfoDB' + '_' + EMRPracticeModel.PracticeID;//CREATING DB PER PRACTICE

EMRAdmin.factory('CommonDemographicsFactory', ['$q', '$rootScope', '$filter', 'AuditLogService', '$http', '$state', '$timeout', function ($q, $rootScope, $filter, AuditLogService, $http, $state, $timeout) {


    var demographicsstorage;
    var desiredCapacity = 100 * 1024 * 1024; //100MB

    var IsDemographicsLocalStorageNotInitialized = false;
    var DemographicsDBCurVersionNumber = 'DemographicsVersionInfo^' + GetCurrentLoadedEHRVersionNumber();
    var EHRVersion = GetCurrentLoadedEHRVersionNumber();
    console.log("V : " + EHRVersion);


    var DemographicsStatusList = 'demographicsStatusList^';
    var DemographicsCountyList = 'demographicsCountyList^';
    var DemographicsDetailedFieldsCustList = 'demographicsDetailedFieldsList^';




    var DemographicsLocalStorageFactoryInstance = {

        // ============================================================================= INITIALISE LOCAL STORAGE START ===========================

        InitializeEHRLocalStorage: function () {


            var deferred = $q.defer();

            if (EHRisMobile.any() || IsDemographicsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.reject();
                });
            }
            else {
                //APENDING VERSION NUMBER
                tempDemographicsLocalStorageName = tempDemographicsLocalStorageName;

                if ((typeof LargeLocalStorage).toString().toLowerCase() == "undefined" || (typeof LargeLocalStorage).toString().toLowerCase() == "null") {
                    $timeout(function () {
                        deferred.reject();
                    });
                }
                else {

                    demographicsstorage = new LargeLocalStorage({

                        size: desiredCapacity,// desired capacity, in bytes.

                        // optional name for your LLS database. Defaults to lls.
                        // This is the name given to the underlying
                        // IndexedDB or WebSQL DB or FSAPI Folder.
                        // LLS's with different names are independent.
                        name: tempDemographicsLocalStorageName

                        // the following is an optional param 
                        // that is useful for debugging.
                        // force LLS to use a specific demographicsstorage implementation
                        // forceProvider: 'IndexedDB' or 'WebSQL' or 'FilesystemAPI'
                    });

                    demographicsstorage.initialized.then(function (capacity) {

                        //console.log(capacity);
                        if (capacity != -1 && capacity != desiredCapacity) {
                            // the user didn't authorize your demographicsstorage request
                            // so instead you have some limitation on your demographicsstorage
                        }





                        if (hasValue(demographicsstorage) && demographicsstorage.ready()) {
                            //CHECK VERSION INFO
                            DemographicsLocalStorageFactoryInstance.CheckLocalStorageVersion().then(function (serviceResponse) {
                                deferred.resolve("success");
                            });
                        }
                        else {

                            if (capacity == null)
                                //local demographicsstorage has not been initialized 
                                IsDemographicsLocalStorageNotInitialized = true;
                        }

                        //demographicsstorage.ls().then(function (docKeys) {
                        //    if (docKeys != null && docKeys != undefined && docKeys.length > 0) {
                        //        angular.forEach(docKeys, function (docId) {
                        //            demographicsstorage.rm(DemographicsLocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                        //            });
                        //        });
                        //    }
                        //});
                    });
                }
            }
            return deferred.promise;
        },

        // ============================================================================= INITIALISE LOCAL STORAGE END ===========================



        hasValueInLLS: function (inputValue) {
            if (!hasValue(inputValue)) {
                return false;
            }

            if (typeof inputValue == "string" && (inputValue.toString().trim().toUpperCase() == NoDataFromDataBase.trim())) {
                inputValue = null;
                return true;
            } else {
                return true;
            }


        },

        // ============================================================================= SET CONTNET FROM LOCAL STORAGE START ===========================
        SetContentInEHRLocalStorage: function (docId, docData) {

            if (EHRisMobile.any() || IsDemographicsLocalStorageNotInitialized) {
                return;
            }

            if (hasValue(demographicsstorage) && demographicsstorage.ready()) {

                if (hasValue(docData)) {
                    docData = LZString144.compressToUTF16(JSON.stringify(docData));
                }
                else {
                    docData = NoDataFromDataBase;
                }
                // docId = DemographicsLocalStorageFactoryInstance.appendDocIDwithVersion(docId);

                demographicsstorage.setContents(DemographicsLocalStorageFactoryInstance.getUniqueId(docId), docData).then(function () {
                    //alert('doc written');
                });
            }

        },
        // ============================================================================= SET CONTNET FROM LOCAL STORAGE END ===========================


        // ============================================================================= GET UNIQUE ID START ===========================
        getUniqueId: function (docId) {


            return docId + "_" + EMRPracticeModel.PracticeID + "_" + EMRPracticeModel.ApplicationType + "_" + EHRVersion;
        },
        // ============================================================================= GET UNIQUE ID END ===========================



        // ============================================================================= CHECK LOCAL STORAGE VERSION START ===========================
        CheckLocalStorageVersion: function () {

            var deferred = $q.defer();

            DemographicsLocalStorageFactoryInstance.GetContentInEHRLocalStorage("DemographicsVersionInfo").then(function (serviceResponse) {

                if (isError(serviceResponse) || !DemographicsLocalStorageFactoryInstance.hasValueInLLS(serviceResponse)) {
                    //NO DATA AVILABLE
                    //SO ADDING DATA
                    DemographicsLocalStorageFactoryInstance.SetContentInEHRLocalStorage("DemographicsVersionInfo", DemographicsDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                    deferred.resolve("success");
                } else {
                    //Version Info Avialbe and Not Matched with Current Version
                    if (typeof serviceResponse == "string" && (serviceResponse.toString().trim().toUpperCase() != DemographicsDBCurVersionNumber.trim().toUpperCase())) {
                        if (hasValue(demographicsstorage) && demographicsstorage.ready()) {
                            demographicsstorage.clear().then(function () {
                                //console.log('LOCAL STORAGE CLEARED & New Version Details Added to LOCAL STORAGE');
                                DemographicsLocalStorageFactoryInstance.SetContentInEHRLocalStorage("DemographicsVersionInfo", DemographicsDBCurVersionNumber);//ADDING EASY FORM BINARY TO LLS, IF DATA ALREADY EXISTS, THEN IT WILL OVERRIDE
                                deferred.resolve("success");
                            });// clear the entire database

                        }
                    } else {
                        deferred.resolve("success");
                    }
                }
            });
            return deferred.promise;
        },
        // ============================================================================= CHECK LOCAL STORAGE VERSION END ===========================



        // ============================================================================= GET CONTNET FROM LOCAL STORAGE START ===========================
        GetContentInEHRLocalStorage: function (docId) {

            var deferred = $q.defer();

            if (EHRisMobile.any() || IsDemographicsLocalStorageNotInitialized) {
                setTimeout(function () {
                    deferred.resolve(undefined);
                });
            }
            else {
                try {
                    if (hasValue(demographicsstorage) && demographicsstorage.ready()) {

                        $rootScope.$broadcast("ajax-loader-countincrement");

                        //docId = DemographicsLocalStorageFactoryInstance.appendDocIDwithVersion(docId);

                        demographicsstorage.getContents(DemographicsLocalStorageFactoryInstance.getUniqueId(docId)).then(function (contents) {

                            if (contents == NoDataFromDataBase) {
                                deferred.resolve(NoDataFromDataBase);
                            }
                            else
                                deferred.resolve(contents != undefined && contents != null && contents != "" ? JSON.parse(LZString144.decompressFromUTF16(contents)) : undefined);

                            $rootScope.$broadcast("ajax-loader-countdecrement");

                        }, function (error) {
                            $rootScope.$broadcast("ajax-loader-countdecrement");
                            deferred.resolve(undefined);
                            console.log('Normal Error Back From Local Storage');
                        });
                    }
                    else {
                        setTimeout(function () {
                            deferred.resolve(undefined);
                        });
                    }
                } catch (e) {
                    //Some Times are getting errors Like 
                    // -->  Failed to execute 'transaction' on 'IDBDatabase':
                    $rootScope.$broadcast("ajax-loader-countdecrement");
                    deferred.resolve(undefined);
                    console.log('Catch Error Back From Local Storage');
                }
            }
            return deferred.promise;
        },
        // ============================================================================= GET CONTNET FROM LOCAL STORAGE END ===========================

        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE START ===========================
        RemoveContentInEHRLocalStorage: function (docId) {
            if (EHRisMobile.any() || IsDemographicsLocalStorageNotInitialized) {
                return;
            }

            if (hasValue(demographicsstorage) && demographicsstorage.ready()) {

                demographicsstorage.rm(DemographicsLocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
                    console.log('Remove Success');

                }, function(err) {
                    console.error('Failed removal');
                    console.error(err);
                });
            }
        },
        // ============================================================================= REMOVE SELECTED CONTNET IN LOCAL STORAGE END ===========================


        RemoveContentInEHRLocalStorageAsync: function () {

            DemographicsLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsStatusList + EMRPracticeModel.PracticeID);
            console.log("Demographics Status Removed from Local Storage");

            DemographicsLocalStorageFactoryInstance.RemoveContentInEHRLocalStorage(DemographicsCountyList + EMRPracticeModel.PracticeID);
            console.log("Demographics County Removed from Local Storage");

            //var deferred = $q.defer();

            //if (EHRisMobile.any() || IsDemographicsLocalStorageNotInitialized) {
            //    setTimeout(function () {
            //        deferred.resolve('success');
            //    })
            //}
            //else {
            //    if (hasValue(demographicsstorage) && demographicsstorage.ready()) {

            //        demographicsstorage.rm(LocalStorageFactoryInstance.getUniqueId(docId)).then(function () {
            //            deferred.resolve('success');
            //        }, function () {
            //            deferred.resolve('success');
            //        });
            //    }
            //    else {
            //        setTimeout(function () {
            //            deferred.resolve('success');
            //        })
            //    }
            //}

            //return deferred.promise;
        },
    }

    return DemographicsLocalStorageFactoryInstance;


}]);